import { OrderNotesInterface } from "@/interface/business/item.interface";
import { OrderNoteType } from "@/types/orders";

export default class OrderNotes implements OrderNotesInterface {
  address_note: string = "";
  delivery_note: string = "";
  delivery_date: string = ""; // "2021-02-02"
  delivery_time: string = ""; // "17:30"
  payment_status?: string = ""; //
  constructor(data?: OrderNoteType) {
    if (data) {
      this.address_note = data.address_note || "";
      this.delivery_note = data.delivery_note || "";
      this.delivery_date = data.delivery_date || ""; // "2021-02-02"
      this.delivery_time = data.delivery_time; // "17:30"
      this.payment_status = data?.payment_status; //
    }
  }
}
